export function generateFingerprint() {
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };

  const setCookie = (name, value, days = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  };

  const existingUUID = getCookie('uuid');
  if (existingUUID) {
    return existingUUID;
  }

  const newUUID = crypto.randomUUID();
  setCookie('uuid', newUUID);
  return newUUID;
}